var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 59,
    viewBox: "0 0 65 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 27.0314V29.5154C56.9967 35.3378 55.1113 41.0031 51.6252 45.6664C48.139 50.3297 43.2389 53.7411 37.6555 55.392C32.0721 57.0428 26.1046 56.8446 20.6431 54.8268C15.1815 52.8091 10.5186 49.0799 7.34959 44.1955C4.18062 39.3111 2.67544 33.5332 3.05853 27.7235C3.44162 21.9138 5.69246 16.3835 9.47535 11.9575C13.2583 7.53156 18.3705 4.44699 24.0497 3.16385C29.7289 1.88071 35.6707 2.46776 40.989 4.83745",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 2.5L32.5 32.53L23.5 23.53",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeTask);
export default __webpack_public_path__ + "static/media/type_task.7ea730e9fd2c26f2774afc745062eb6f.svg";
export { ForwardRef as ReactComponent };